<template>

  <Loading :show="showLoading" />

  <!--   Big container   -->
  <div class="container">
    <div class="row">

      <!-- <div class="col-sm-8 col-sm-offset-2"> -->
      <div class="col-sm-8 col-sm-offset-2">
        <div style="text-align: center; margin-top: 2rem;">
          <a href="javascript:void(0);" @click="abrirSiteCliente()" >
            <img style="width: 12%;" src="assets/img/cliqxone/logo.png" /> 
          </a>
        </div>
        <!--      Wizard container        -->
        <div class="wizard-container" style="padding-top: 14px;">
          <div class="card wizard-card" data-color="blue" id="wizard" style="display: block;">
            <form action="" method="" novalidate="novalidate">
              
              <!-- ==================== -->
              <!-- TITULO E DESCRIÇÃO   -->
              <!-- ==================== -->
              <div class="wizard-header">
                <h3 class="wizard-title" style="font-size: 23px;">Pagamento</h3>
                <h5 style="font-size: 16px; font-weight: 400;">Insira suas informações para concluir o pagamento.</h5>
              </div>

              <!-- ================ -->
              <!-- BARRA DE MENU    -->
              <!-- ================ -->
              <div v-on:click.stop class="wizard-navigation">
                <ul class="nav nav-pills">
                  <li style="width: 25%" class="active" >
                    <a href="#adesion" data-toggle="tab" aria-expanded="false">Adesão</a>
                  </li>
                  <li style="width: 25%" class="">
                    <a href="#details" data-toggle="tab" aria-expanded="false">Dados pagamento</a>
                  </li>
                  <li style="width: 25%" class="">
                    <a href="#captain" data-toggle="tab" aria-expanded="false">Identificação</a>
                  </li>
                  <li style="width: 25%" class="">
                    <a href="#description" data-toggle="tab" aria-expanded="false">Resumo</a>
                  </li>
                </ul>
                <div class="moving-tab" style="width: 250px; transform: translate3d(-8px, 0px, 0px); transition: transform 0s ease 0s;">
                </div>
              </div>


              <div class="tab-content" style="padding-top: 3rem; padding-right: 3.5rem; padding-left: 3.5rem;">
              
              <!-- ================= -->
              <!-- ADESÃO: INICIO -->
              <!-- ================= -->
              <div class="tab-pane active" id="adesion">
                <div class="row">
                  <!-- =================== -->
                  <!-- ADESÃO: TEXTO       -->
                  <!-- =================== -->
                  <div class="row" style="margin-top: 5rem; text-align: center;">
                    <p>
                      Ao continuar com o pagamento, você concorda com os<br> 
                      <span style="font-weight: 500;">Termos de Adesão</span>.
                    </p>
                    <p>
                      <a href="https://checkout.cliqx.com.br/cliqxone/termodeuso.pdf" target="_blank">Clique aqui para acessar.</a>
                    </p>
                  </div>
                  <div class="row" style="text-align: -webkit-center;"> 
                    <input type="button" v-on:click="handlerBotaoAvancar()" class="btn btn-next btn-fill btn-wd btn-info" name="next" value="Prosseguir" style="margin-top: 3rem" >
                  </div>
                </div>
              </div>
              



              <!-- ================= -->
              <!-- PAGAMENTO: INICIO -->
              <!-- ================= -->
              <div class="tab-pane" id="details">
                <div class="row">

                    <!-- ======================= -->
                    <!-- PAGAMENTO: TITULO       -->
                    <!-- ======================= -->
                    <div class="col-sm-12">
                      <h4 class="info-text">
                        <strong>Dados do titular do cartão.</strong>
                      </h4>
                    </div>
                    
                    <!-- ================================================= -->
                    <!-- PAGAMENTO: NUMERO, VALIDADE E CODIGO DE SEGURANÇA  -->
                    <!-- ================================================= -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-6">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="">Número do cartão</label>
                            <input name="pNumero" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   v-maska="'#### #### #### ####'" 
                                   v-model="pgnumerocartao" 
                                   placeholder="Ex: 0000 0000 0000 00000" 
                                   required 
                                   aria-invalid="true" />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgnumerocartao">{{msgerror.pgnumerocartao}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-2">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="">Validade</label>
                            <input name="pValidade" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                  v-maska="'##/##'" 
                                  v-model="pgvalidadecartao"
                                  placeholder="MM/AA"
                                  required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgvalidadecartao">{{msgerror.pgvalidadecartao}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="">Código de segurança</label>
                            <input name="pCvv" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   v-maska="'###'" 
                                   v-model="pgcvvcartao"
                                   placeholder="CVV" 
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgcvvcartao">{{msgerror.pgcvvcartao}}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- ================================== -->
                    <!-- PAGAMENTO: NOME E DATA NASCIMENTO  -->
                    <!-- ================================== -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-6">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="">Nome completo</label>
                            <input name="pNomeCompleto" 
                                   type="text" 
                                   autocomplete="nope"
                                   class="form-control"
                                   v-model="pgnomecompleto"
                                   placeholder="Ex: João Silva Reis"
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgnomecompleto">{{msgerror.pgnomecompleto}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="">Data de Nascimento</label>
                            <input name="pDtNascimento" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   v-maska="'##/##/####'"
                                   v-model="pgdatanascimento"
                                   placeholder="DD/MM/AAAA"
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgdatanascimento">{{msgerror.pgdatanascimento}}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- ======================================== -->
                    <!-- PAGAMENTO: CPF E NUMERO DE PARCELAS      -->
                    <!-- ======================================== -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-6">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="">CPF</label>
                            <input name="pCpf" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   v-maska="'###.###.###-##'"
                                   v-model="pgcpf"
                                   placeholder="000.000.000-00" 
                                   required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgcpf">{{msgerror.pgcpf}}</span>
                          </div>
                        </div>
                      </div>
                       <div class="col-sm-6">
                        <div class="" style="margin: 27px 0 0 0">
                          <!--<div class="">-->
                            <label class="">Valor mensal</label>
                            <br/>
                            <select class="" style="padding: 8px;">
                              <option>R$ {{pedidoResponse.valorTotal.toFixed(2)}}</option>
                            </select>
                            <span class="material-input"></span>
                          <!--</div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ====================== -->
                <!-- IDENTIFICACAO: INICIO  -->
                <!-- ====================== -->
                <div class="tab-pane" id="captain">
                  <div class="row">

                    <!-- ======================= -->
                    <!-- IDENTIFICACAO: TITULO   -->
                    <!-- ======================= -->
                    <div class="col-sm-12">
                      <h4 class="info-text">
                        <strong>Dados da Empresa.</strong>
                      </h4>
                    </div>

                    <!-- ========================================  -->
                    <!-- IDENTIFICACAO: CNPJ   -->
                    <!-- ========================================  -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-6">
                        <div class="form-group label-floating">
                          <label class="">CPF/CNPJ</label>
                          <input name="cpcnpj" 
                                  type="tel" 
                                  class="form-control"
                                  autocomplete="nope"
                                  v-maska="['##.###.###/####-##','###.###.###-##']"
                                  placeholder="Ex: 00.000.000/0001-00 ou 000.000.000-00" 
                                  v-model="cpcnpj"
                                  required />
                          <span class="material-input"></span>
                        </div>
                      </div>
                      <div class="col-sm-6" v-show="showNomeEmpresa">
                        <div class="form-group label-floating">
                          <label class="">Nome Empresa</label>
                          <input name="cpnomeempresa" 
                                  type="text" 
                                  class="form-control"
                                  autocomplete="nope"
                                  placeholder="Ex. Cliqx" 
                                  v-model="cpnomeempresa"
                                  required />
                          <span class="material-input"></span>
                        </div>
                      </div>
                    </div>

                    <!-- ========================================  -->
                    <!-- IDENTIFICACAO: NOME RESPONSAVEL   -->
                    <!-- ========================================  -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-6">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="">Nome responsável</label>
                            <input name="cpnomecompleto" 
                                   type="text" 
                                   class="form-control"
                                   autocomplete="nope"
                                   placeholder="Ex: João Maria" 
                                   v-model="cpnomecompleto"
                                   required />
                            <span class="material-input"></span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="">Telefone</label>
                            <input name="cptelefone" 
                                   type="tel" 
                                   class="form-control" 
                                   autocomplete="nope" 
                                   placeholder="Ex: (11) 00000-0000"
                                   v-maska="'(##) #####-#####'"
                                   v-model="cptelefone"
                                   required />
                            <span class="material-input"></span>
                          </div>
                        </div>
                      </div>

                    </div>


                    <!-- ======================================== -->
                    <!-- IDENTIFICACAO: EMAIL E CEP               -->
                    <!-- ======================================== -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
        
                      <div class="col-sm-6">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="">E-mail</label>
                            <input name="cpemail" 
                                type="text" 
                                class="form-control" 
                                autocomplete="nope" 
                                placeholder="Ex: padariamaravilhosa@email.com"
                                v-model="cpemail"
                                required />
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="">
                          <div class="form-group label-floating">
                            <label class="">Cep Endereço Comercial </label>
                            <input name="" 
                                  type="tel" 
                                  class="form-control" 
                                  autocomplete="nope" 
                                  placeholder="00000-000"
                                  v-maska="'#####-###'"
                                  v-model="pgcep"
                                  required />
                            <span class="material-input"></span>
                            <span class="error" v-if="msgerror.pgcep">{{msgerror.pgcep}}</span>
                          </div>
                          <a href="javascript:void(0);" @Click="abrirSiteCorreio()" style="font-size: 12px; color: #5aaac9;">Não sei meu cep </a>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>


                

                <!-- ====================== -->
                <!-- RESUMO: INICIO  -->
                <!-- ====================== -->
                <div class="tab-pane" id="description">
                  <div class="row">
                  
                  
                    <!-- ======================= -->
                    <!-- RESUMO: TITULO       -->
                    <!-- ======================= -->
                    <div class="col-sm-12">
                      <h4 class="info-text">
                        <strong>Confirme sua compra.</strong>
                      </h4>
                    </div>
                    
                    <!-- ================================================= -->
                    <!-- RESUMO: NUMERO PEDIDO  -->
                    <!-- ================================================= -->
                    <!--
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-12">
                        <div class="input-group">
                          <div class="form-group label-floating">
                            <label class="control-label">Número do pedido</label>
                            <input name="rNumeroPedido" 
                                   type="tel" 
                                   class="form-control"
                                   :value="pedidoResponse.pedido+' '"
                                   disabled="true"
                                   autocomplete="nope" />
                            <span class="material-input"></span>
                          </div>
                        </div>
                      </div>  
                    </div>
                    -->

                    <!-- ================================================= -->
                    <!-- RESUMO: ITEM PEDIDO E PARCELA  -->
                    <!-- ================================================= -->
                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-6">
                        <div class="input-group">
                          <div class="form-group label-floating">
                            <label class="control-label">Itens do Pedido</label>
                            <input name="rItem" 
                                   type="text" 
                                   class="form-control"
                                    :value="pedidoResponse.itemPedido+' '"
                                   disabled="true"
                                   autocomplete="nope" />
                            <span class="material-input"></span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-5">
                        <div class="input-group">
                          <div class="form-group label-floating">
                            <!-- <label class="control-label">{{parcelas.quantity}}x de R$ {{parcelas.installmentAmount}} {{parcelas.interestFree ? '(sem juros)' : '(com juros)' }}</label> -->
                            <!-- <label class="control-label">1x de R$ {{pedidoResponse.valorTotal.toFixed(2)}} (sem juros)</label> -->
                            <label class="control-label">Valor mensal</label>
                            <input name="rPagar" 
                                   type="text" 
                                   class="form-control"
                                   :value="'R$ ' + pedidoResponse.valorTotal.toFixed(2)"
                                   disabled="true"
                                   autocomplete="nope" />
                            <span class="material-input"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" style="padding-left: 10px; padding-right: 10px;">
                      <div class="col-sm-6">
                        <div class="input-group">
                          <div class="form-group label-floating">
                            <label class="control-label">Forma de pagamento</label>
                            <input name="rForma" 
                                   type="tel" 
                                   class="form-control"
                                   autocomplete="nope"
                                   disabled="true"
                                   :value="pedidoResponse.formaPagamento+' '" />
                            <span class="material-input"></span>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="input-group">
                          <div class="form-group" style="background-color: #c8c8c833; border-radius: 10px; padding: 10px;">
                            {{pedidoResponse.mensagem}}                          
                          </div>
                        </div>
                      </div>

                    </div>
                  </div> 
                </div>
              </div>
              
              <div class="wizard-footer">
	              <div class="pull-right">
	                <input type="button" v-if="showBtnAvancar" class="btn btn-next btn-fill btn-wd btn-info" name="next" value="AVANÇAR" style="" >
	                <input type="button" @click="SendPayment()" class="btn btn-finish btn-fill btn-wd btn-info" name="finish" value="CONCLUIR" style="display: none;">
	              </div>
	              <div class="pull-left">
	                <input type="button" class="btn btn-previous btn-fill btn-default btn-wd disabled" name="previous" value="Voltar">
	              </div>
	              <div class="clearfix"></div>
	            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <div class="container text-center">
       By <a href="javascript:void(0);" @click="abrirSiteCliqx()" style="font-weight: 400;">Cliqx.com</a>
    </div>
   
  </div>


  <!-- ============================ -->
  <!-- MODAL: ENDEREÇO DE COBRANÇA  -->
  <!-- ============================ -->
  <div class="modal fade" id="modalEnderecoCobranca" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog  modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header" style="display: none">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="material-icons">clear</i>
          </button>
        </div>
        <div class="modal-body" >
          <div class="tab-pane" id="captain">
            <div class="row">
              <div class="col-sm-12">
                <h4 class="info-text" style="text-align: -webkit-center;" >
                  <strong>Localização da Empresa</strong>
                </h4>
              </div>
              <!-- CEP -->
              <div class="row" style="padding-left: 25px; padding-right: 25px;">
                <div class="col-sm-7">
                  <div class="input-group">
                    <div class="form-group label-floating">
                      <label class="">Cep</label>
                      <input name="pgcep" type="tel" class="form-control color-blue-focus" autocomplete="nope" v-maska="'#####-###'" v-model="pgcep" required />
                      <span class="material-input"></span>
                      <span class="error" v-if="msgerror.pgcep">{{msgerror.pgcep}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" style="padding-left: 25px; padding-right: 25px;">
                <!-- ENDEREÇO -->
                <div class="col-sm-7">
                  <div class="">
                    <div class="form-group label-floating">
                      <label class="">Endereço</label>
                      <input name="pgendereco" type="text" class="form-control color-blue-focus" autocomplete="nope" v-model="pgendereco" required />
                      <span class="material-input"></span>
                      <span class="error" v-if="msgerror.pgendereco">{{msgerror.pgendereco}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="">
                    <div class="form-group label-floating">
                      <label class="">N°</label>
                      <input name="pgendereconumero" type="tel" class="form-control color-blue-focus" autocomplete="nope" v-model="pgendereconumero"  required />
                      <span class="material-input"></span>
                      <span class="error" v-if="msgerror.pgendereconumero">{{msgerror.pgendereconumero}}</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row" style="padding-left: 25px; padding-right: 25px;">                  
                <!-- BAIRRO -->
                <div class="col-sm-7">
                  <div class="">
                    <div class="form-group label-floating">
                      <label class="">Bairro</label>
                      <input name="pgbairro" type="text" class="form-control color-blue-focus" autocomplete="nope" v-model="pgbairro"  required />
                      <span class="material-input"></span>
                      <span class="error" v-if="msgerror.pgbairro">{{msgerror.pgbairro}}</span>
                    </div>
                  </div>
                </div>
                <!-- COMPLEMENTO -->
                <div class="col-sm-5">
                  <div class="">
                    <div class="form-group label-floating">
                      <label class="">Complemento</label>
                      <input name="pgenderecocomplemento" type="text" class="form-control color-blue-focus" autocomplete="nope" v-model="pgenderecocomplemento"  required />
                      <span class="material-input"></span>
                      <span class="error" v-if="msgerror.pgenderecocomplemento">{{msgerror.pgenderecocomplemento}}</span>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row" style="padding-left: 25px; padding-right: 25px;">
                <!-- CIDADE -->
                <div class="col-sm-4">
                  <div class="">
                    <div class="form-group label-floating">
                      <label class="">Cidade</label>
                      <input name="pgcidade" type="text" class="form-control color-blue-focus" autocomplete="nope" v-model="pgcidade"  required />
                      <span class="material-input"></span>
                      <span class="error" v-if="msgerror.pgcidade">{{msgerror.pgcidade}}</span>
                    </div>
                  </div>
                </div>
                <!-- ESTADO -->
                <div class="col-sm-2 col-sm-offset-3">
                  <div class="">
                    <div class="form-group label-floating">
                      <label class="">Estado</label>
                      <input name="pgestado" type="text" class="form-control color-blue-focus" autocomplete="nope" v-model="pgestado"  required />
                      <span class="material-input"></span>
                      <span class="error" v-if="msgerror.pgestado">{{msgerror.pgestado}}</span>
                    </div>
                  </div>
                </div>
              </div>




            </div>
          </div>
        </div>
        <div class="modal-footer" style="border-top: none;">
          <button type="button" class="btn btn-next btn-fill btn-wd btn-info" data-dismiss="modal">Concluir</button>
        </div>
      </div>
    </div>
  </div>

  <!-- =========================== -->
  <!-- MODAL: TRANSAÇÃO REALIZADA  -->
  <!-- =========================== -->
  <div class="modal fade" id="modalTransacaoRealizada" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header" style="border-bottom: none;">
          <!--
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="material-icons">clear</i>
          </button>
          -->
        </div>
        <div class="modal-body">

          <div class="col-sm-12" style="margin-bottom: 2rem; margin-top: -10px;">
            <h4 class="info-text" style="text-align: -webkit-center;" >
              <strong>Compra concluída!</strong>
            </h4>
          </div>
          
          <div>
            <p><strong>Nº do pedido:</strong> {{statusPagamentoResponse.pedido}}</p>
            <p><strong>Data transação:</strong> {{statusPagamentoResponse.datatransacao}}</p>
            <p><strong>Status pagamento</strong> {{statusPagamentoResponse.pagamento}}</p>
            <p><strong>Forma de pagamento:</strong> Cartão de crédito</p>
            <p><strong>Valor total:</strong> R$ {{statusPagamentoResponse.valor}}</p>
          </div>
          
        </div>
      </div>
    </div>
  </div>

</template>


<script>
import { maska } from 'maska';

import Pagamento      from '../model/Pagamento.js';
import Parcelas       from '../model/Parcelas.js';
import Comprador      from '../model/Comprador.js';
import PedidoResponse from '../model/PedidoResponse.js';
import Service        from '../services/Api.js';
import Loading        from '../components/Loading/index.vue'; 

export default {

  directives: { maska },
  components: { Loading },

  /* props: [ 'pedidoResponse'],*/
  props: {pedidoResponse: PedidoResponse},
  data: () => ({ 

    pagamento: Pagamento,
    parcelas: Parcelas,
    comprador: Comprador,
    parcelasLista: [],
    showLoading: false,
    showBtnAvancar: false,

    statusPagamentoResponse: {
      status: '',
      pagamento: '',
      datatransacao: '',
      valor: 0,
      pedido: '',
    },

    pgSenderHash: '',
   
    msgerror: [],
    pgnumerocartao: '',
    pgvalidadecartao: '',
    pgcvvcartao: '',
    pgnomecompleto: '',
    pgdatanascimento: '',
    pgcpf: '',
    pgtelefone: '',
    pgcep: '',
    pgendereco: '',
    pgendereconumero: '',
    pgenderecocomplemento: '',
    pgbairro: '',
    pgcidade: '',
    pgestado: '',

    
    cpnomecompleto: ' ',
    cpcpf: ' ',
    cpcnpj: ' ', 
    cpdatanascimento: ' ',
    cpemail: '',
    cpconfirmaemail: '',
    cptelefone: ' ',
    cpnomeempresa: '',

    
    teste: false

  }),

  computed: {
    showNomeEmpresa() {
      //Exibe nome empresa somente quando for cpf, no caso cpf esta formatado
      //por isto comparo o tamanho com 14 caracteres
      return this.cpcnpj.length == 14;
    }
  },

  created(){
    this.pagamento = new Pagamento()
    this.parcelas  = new Parcelas()
    this.comprador = new Comprador()
    console.log("11 " + this.showLoading);
  },
  
  watch: {
    pgnumerocartao:   function(newValue, oldValue){ this.validaPagadorCartaoNumero(newValue) },
    pgvalidadecartao: function(newValue, oldValue){ this.validaPagadorCartaoValidade(newValue) },
    pgcvvcartao:      function(newValue, oldValue){ this.validaPagadorCartaoCvv(newValue) },
    pgnomecompleto:   function(newValue, oldValue){ this.validaPagadorCartaoNomeCompleto(newValue) },
    pgdatanascimento: function(newValue, oldValue){ this.validaPagadorDataNascimento(newValue) },
    pgcpf:            function(newValue, oldValue){ this.validaPagadorCpf(newValue) },
    pgtelefone:       function(newValue, oldValue){ this.validaPagadorTelefone(newValue) },
    pgcep:            function(newValue, oldValue){ this.validaPagadorCep(newValue) },

    pgendereco:       function(newValue, oldValue){ this.validaPagadorEndereco(newValue) },
    pgendereconumero: function(newValue, oldValue){ this.validaPagadorEnderecoNumero(newValue) },
    pgenderecocomplemento: function(newValue, oldValue){ this.validaPagadorEnderecoComplemento(newValue) },
    pgbairro:         function(newValue, oldValue){ this.validaPagadorBairro(newValue) },
    pgcidade:         function(newValue, oldValue){ this.validaPagadorCidade(newValue) },
    pgestado:         function(newValue, oldValue){ this.validaPagadorEstado(newValue) },

    cpnomecompleto:   function(newValue, oldValue){ this.validaCompradorNome(newValue) },
    cpcpf:            function(newValue, oldValue){ this.validaCompradorCpf(newValue) },
    cpcnpj:           function(newValue, oldValue){ this.validaCompradorCnpj(newValue) },
    cpdatanascimento: function(newValue, oldValue){ this.validaCompradorDatanascimento(newValue) },
    cpemail:          function(newValue, oldValue){ this.validaCompradorEmail(newValue) },
    cpconfirmaemail:  function(newValue, oldValue){ this.validaCompradorConfirmarEmail(newValue) },
    cptelefone:       function(newValue, oldValue){ this.validaCompradorTelefone(newValue) },
    cpnomeempresa:    function(newValue, oldValue){ this.validaCompradorNomeEmpresa(newValue) },

  },
  
  methods: {

      abrirSiteCorreio: function(){
        window.open("https://buscacepinter.correios.com.br/app/endereco/index.php", "_blank");    
      },

      abrirSiteCliqx: function(){
        window.open("https://cliqx.com.br", "_blank");    
      },

      abrirSiteCliente: function(){
        window.open("https://cliqx.com.br", "_blank");
      },


      handlerBotaoAvancar: function(){
        this.showBtnAvancar = !this.showBtnAvancar;
      },



       pesquisaCep: async function(){
        
        let response = await Service.pesquisaCep(this.pagamento.ownerCep);
        if (!response.data.hasOwnProperty("erro")) {
          //Senão houve erro ao buscar o cep, preenche os dados.
          this.pgbairro              = response.data.bairro;
          this.pgcep                 = response.data.cep;
          this.pgenderecocomplemento = response.data.complemento;
          this.pgendereco            = response.data.logradouro;
          this.pgcidade              = response.data.localidade;
          this.pgestado              = response.data.uf;
        }else {
          alert(`Não localizamos informações para o cep: ${this.pagamento.ownerCep}!\nCaso o cep esteja correto, infome os demais dados.`)
        }
        
        $("#modalEnderecoCobranca").modal();
      
      },

      SendPayment: function(){
        debugger;
        const self = this;
        this.showLoading = true;
        let nomeResponsavel = this.comprador.fullName;
        
        if (this.comprador.companyName != null && this.comprador.companyName.trim() != "" && this.comprador.cnpj.length == 14) {
          nomeResponsavel += "|" + this.comprador.companyName;
        }

        const obj = {
                    "plano":this.$route.params.uuid,
                    "address":{"cep":this.pagamento.ownerCep, "address":this.pagamento.ownerAddress, "number":this.pagamento.ownerAddressNumber ,"complement":this.pagamento.ownerAddressComplement, "district":this.pagamento.ownerDistrict, "state":this.pagamento.ownerState, "city": this.pagamento.ownerCity},
                    "identified":{"cnpj":this.comprador.cnpj, "nameresponsible": nomeResponsavel, "phone":this.comprador.phone,"email":this.comprador.email, "companyname": this.comprador.companyname },
                    "payment":{"number":this.pagamento.cardNumber, "validate":this.pagamento.cardDataValidate, "cvv": this.pagamento.cardCvv, "namefull":this.pagamento.ownerFullname, "birthdate": this.pagamento.ownerDateBirth, "cpf": this.pagamento.ownerCpf}, 
                  }

      let data = JSON.stringify(obj);
      Service.enviaCheckout(data).then(response => {
        console.log(response);
        self.statusPagamentoResponse = response.data;
        console.log(self.statusPagamentoResponse);
        self.showLoading = false;
        $('#modalTransacaoRealizada').modal('show')
        
      }).catch( error => {
        self.showLoading = false;
        console.log(error)
        alert('Pagamento não aprovado.');
      })
    },

      
      /* USADOS NOS PAG SEGURO */
      validShowinstallment: function(){
        if(this.pagamento.cardBrand === null || this.pagamento.cardBrand.trim() === ""){
          alert('Para visualizar a parcelas, informe os 6 primeiros digitos do cartão')
          return;
        }
      },


      addHashSender: function(){
        this.pgSenderHash = '';
        let self = this;
        PagSeguroDirectPayment.onSenderHashReady(function(response){
            if(response.status == 'error') {
              console.log("Error hash" + response.message);
              return false;
            }
            self.pgSenderHash = response.senderHash;
            //console.log(self.pgSenderHash);
        })
      },

      getCardBrand: function(){
      
        if(this.pagamento.cardNumber === null)  return
        if(this.pagamento.cardNumber.trim().split(" ").length < 2) return
      
        const cardNumber = this.pagamento.cardNumber.split(" ")[0] + this.pagamento.cardNumber.split(" ")[1]  

        if(cardNumber.length != 6 ) return;

        let self = this;
        PagSeguroDirectPayment.getBrand({
          cardBin: cardNumber.substring(0,6),
          success: function(response) { 
              //console.log(response);
              self.pagamento.cardBrand    = response['brand']['name'];
              self.pagamento.cardCvvSize  = response['brand']['cvvSize'];
              self.getCardinstallment();
              self.addHashSender();
          },
          error: function(response) { console.log(response); }
        })  

      },


    getCardinstallment: function(){
      let self = this;
      PagSeguroDirectPayment.getInstallments({
			  amount: self.pedidoResponse.valorTotal.toString().replace(",", "."),
			  brand:  self.pagamento.cardBrand,
			  maxInstallmentNoInterest: 2, //calculo de parcelas sem juros
			  success: function(response) {
          console.log(response);
          console.log(response['installments'])
          self.parcelasLista  = response['installments'][self.pagamento.cardBrand];
          self.parcelas       = self.parcelasLista[0];
			  },
			  error: function(response) { console.log(response); }
		  })
    },

     getCardTokenAndSendRequest: function(){
       
      if(this.pagamento.cardNumber === null || this.pagamento.cardNumber.length != 19) 
        return;
      
      if(this.pagamento.cardDataValidate === null || this.pagamento.cardDataValidate.length != 5) 
        return;
      
      if(this.pagamento.cardCvv === null && this.pagamento.cardCvv.length != 3)
        return;

      this.showLoading = true;
      let card = this.pagamento.cardNumber.split(" ");
      let cvv  = this.pagamento.cardCvv.trim();
      let date = this.pagamento.cardDataValidate.split("/");
      let self = this;
      // console.log("Cartao:"+card[0].trim()+card[1].trim()+card[2].trim()+card[3].trim());
      // console.log("Cvv:"+cvv);
      // console.log("Data:"+date);
      // console.log("Mes:"+date[0].trim());
      // console.log("Ano:20" + date[1].trim());
      var param = {
        cardNumber: card[0].trim() + card[1].trim() + card[2].trim() + card[3].trim(),
        cvv: cvv,
        expirationMonth: date[0].trim() ,
        expirationYear: "20" + date[1].trim(),
        success: function(response) {
          //console.log(response);
          //console.log(response['card']['token']);
          self.pagamento.cardToken = response['card']['token'];
          //console.log(self.paymentData);
          self.pvtSendPayment();
        },
        error: function(response) { console.log(response); printError(response); this.showLoading = false; }
		  }

      PagSeguroDirectPayment.createCardToken(param);
    },

    
    pvtSendPayment: function(){
      const self = this;
      const obj = {
                    "token":this.pagamento.cardToken,"hash":this.pgSenderHash,"uuid":this.$route.params.uuid,
                    "payer":{"name":this.pagamento.ownerFullname,"cpf":this.pagamento.ownerCpf,"phone":this.pagamento.ownerPhone ,"dtBirth":this.pagamento.ownerDateBirth, "qtnInstallments":1,"valueAmount":this.pedidoResponse.valorTotal, "valueInstallmentAmount": this.pedidoResponse.valorTotal},
                    "buyer":{"name":this.comprador.fullName, "dtBirth":this.comprador.dateBirth, "cpf":this.comprador.cpf ,"phone":this.comprador.phone,"email":this.comprador.email }
                  }

      let data = JSON.stringify(obj);
      Service.enviaCheckout(data).then(response => {
        //console.log(response)
        self.statusPagamentoResponse = response.data;
        this.showLoading = false;
        $('#modalTransacaoRealizada').modal('show')
        
      }).catch( error => {
        this.showLoading = false;
        console.log(error)
        alert('Pagamento não aprovado.');
      })
    },


    /***
    * METODOS PARA VALIDAÇÃO \;
    */
    validaPagadorCartaoNumero: function(novoValor){
      this.pagamento.cardNumber = novoValor;
      const isValid = novoValor.length === 19;
      if(isValid){
        this.msgerror['pgnumerocartao'] = '';
        return;
      }
      this.msgerror['pgnumerocartao'] = 'Informe os 16 digitos do cartão';
     },

    validaPagadorCartaoValidade: function(novoValor){ 
      this.pagamento.cardDataValidate = novoValor;
      const isValid = novoValor.length === 5;
      if(isValid){
        this.msgerror['pgvalidadecartao'] = '';
        return;
      }
      this.msgerror['pgvalidadecartao'] = 'Informe no formato MM/AA';
    },

    validaPagadorCartaoCvv: function(novoValor){
      this.pagamento.cardCvv = novoValor;
      const isValid = novoValor.length === 3;
      if(isValid){
         this.msgerror['pgcvvcartao'] = ''
         return;
      }
      this.msgerror['pgcvvcartao'] = 'Informe codigo de segurança';
    },

    validaPagadorCartaoNomeCompleto: function(novoValor){ 
      this.pagamento.ownerFullname  = novoValor;
      this.comprador.fullName       = novoValor;
      this.cpnomecompleto           = novoValor;
      const isValid = novoValor.trim().split(" ").length > 1;
      if(isValid){
        this.msgerror['pgnomecompleto'] = '';
        return;
      }
      this.msgerror['pgnomecompleto'] = 'Informe o nome conforme está no cartão';
    },

    validaPagadorDataNascimento: function(novoValor){ 
      this.pagamento.ownerDateBirth = novoValor;
      this.comprador.dateBirth      = novoValor;
      this.cpdatanascimento         = novoValor;
      const isValid = novoValor.length === 10;
      if(isValid){
        this.msgerror['pgdatanascimento'] = '';
        return;  
      }
      this.msgerror['pgdatanascimento'] = 'Informe no formato DD/MM/AAAA';
    },

    validaPagadorCpf: function(novoValor){ 
      this.pagamento.ownerPhone = novoValor;
      this.comprador.cpf        = novoValor;
      this.cpcpf                = novoValor;
      const isValid = novoValor.length === 14;
      if(isValid){
        this.msgerror['pgcpf'] = '';
        return;
      }
      this.msgerror['pgcpf'] = 'Informe os 11 digitos do CPF';
    },

    validaPagadorTelefone: function(novoValor){ 
      this.pagamento.ownerPhone = novoValor;  
      this.comprador.phone      = novoValor;  
      this.cptelefone           = novoValor;
      const isValid = novoValor.length === 16 ;
      if(isValid){
        this.msgerror['pgtelefone'] = '';
        return;
      }
      this.msgerror['pgtelefone'] = 'Informe seu telefone com DDD';
    },

    validaPagadorCep: function(novoValor){ 
      this.pagamento.ownerCep = novoValor;    
      const isValid = novoValor.length === 9;
      if(isValid){
        this.msgerror['pgcep'] = '' ;
        this.pesquisaCep();
        return; 
      }
      this.msgerror['pgcep'] = 'Informe os 8 digitos de seu CEP';
      this.pgendereco = '';
      this.pgendereconumero = '';
      this.pgenderecocomplemento = '';
      this.pgbairro = '';
      this.pgcidade = '';
      this.pgestado = '';
    },

    /* --- */
    validaPagadorEndereco: function(novoValor){ 
      this.pagamento.ownerAddress = novoValor;    
      const isValid = novoValor.length > 5;
      if(isValid){
        this.msgerror['pgendereco'] = '' ;
        return; 
      }
      this.msgerror['pgendereco'] = 'Informe um endereço valido';
    },

    validaPagadorEnderecoNumero: function(novoValor){ 
      this.pagamento.ownerAddressNumber = novoValor;    
      this.msgerror['pgendereconumero'] = '' ;
    },

    validaPagadorEnderecoComplemento: function(novoValor){ 
      this.pagamento.ownerAddressComplement = novoValor;    
      this.msgerror['pgenderecocomplemento'] = '' ;
    },

    validaPagadorBairro: function(novoValor){ 
      this.pagamento.ownerDistrict = novoValor;    
      const isValid = novoValor.length > 3;
      if(isValid){
        this.msgerror['pgbairro'] = '' ;
        return; 
      }
      this.msgerror['pgbairro'] = 'Informe um bairro valido';
    },

    validaPagadorCidade: function(novoValor){ 
      this.pagamento.ownerCity = novoValor;    
      const isValid = novoValor.length > 3;
      if(isValid){
        this.msgerror['pgcidade'] = '' ;
        return; 
      }
      this.msgerror['pgcidade'] = 'Informe uma cidade valida';
    },

    validaPagadorEstado: function(novoValor){ 
      this.pagamento.ownerState  = novoValor;    
      const isValid = novoValor.length >= 2;
      if(isValid){
        this.msgerror['pgestado'] = '' ;
        return; 
      }
      this.msgerror['pgestado'] = 'Informe um estado valido';
    },
    /* --- */

    validaCompradorNome: function(novoValor){ 
      this.comprador.fullName = novoValor;
      const isValid = novoValor.trim().split(" ").length > 1;
      if(isValid){
        this.msgerror['cpnomecompleto'] = '';
        return;  
      }
      this.msgerror['cpnomecompleto'] = 'Informe o seu nome completo';
    },

    validaCompradorCpf: function(novoValor){ 
      this.comprador.cpf = novoValor;
      const isValid = novoValor.length === 14;
      if(isValid){
         this.msgerror['cpcpf'] = '';
         return;
      }
      this.msgerror['cpcpf'] = 'Informe os 11 digitos do CPF';
    },

    validaCompradorCnpj: function(novoValor){ 
      this.comprador.cnpj = novoValor;
      /*
      if(isValid){
         this.msgerror['cpcpf'] = '';
         return;
      }
      this.msgerror['cpcpf'] = 'Informe os 11 digitos do CPF';
      */
    },

    validaCompradorDatanascimento: function(novoValor){ 
      this.comprador.dateBirth = novoValor;
      const isValid = novoValor.length === 10;
      if(isValid){
        this.msgerror['cpdatanascimento'] = ''
        return;
      }
      this.msgerror['cpdatanascimento'] = 'Informe no formato DD/MM/AAAA';
    },

    validaCompradorEmail: function(novoValor){
      this.comprador.email = novoValor;
      const isValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(novoValor); 
      if(isValid){
        this.msgerror['cpemail'] = ''  
        return;
      }
      this.msgerror['cpemail'] = 'Informe um email valido';
    },

    validaCompradorConfirmarEmail: function(novoValor){ 
      this.comprador.confirmEmail = novoValor;
      const isValid = novoValor === this.cpemail;
      if(isValid){
        this.msgerror['cpconfirmaemail'] = '';
        return;
      }
      this.msgerror['cpconfirmaemail'] = 'Deve ser igual oa que está no campo email';
    },

    validaCompradorTelefone: function(novoValor){
      this.comprador.phone = novoValor;
      const isValid = novoValor.length === 16; 
      if(isValid){
        this.msgerror['cptelefone'] = '';
        return;
      }
      this.msgerror['cptelefone'] = 'Informe seu telefone com DDD';
    },
    
    validaCompradorNomeEmpresa: function(novoValor){ 
      this.comprador.companyName = novoValor;
      // const isValid = novoValor.trim().split(" ").length > 1;
      // if(isValid){
      //   this.msgerror['cpnomecompleto'] = '';
      //   return;  
      // }
      // this.msgerror['cpnomecompleto'] = 'Informe o seu nome completo';
    },

        
  }

}

</script>
<style>

</style>
